import React, { useEffect, useState } from 'react'
import { Flex, Image, Modal, Stack, Text } from '@mantine/core'
import { lotteryRecords } from '../../../api/merchantService'
import { LotteryRecordVO } from '../../../typings/merchant'

interface ScratchRecordModalProps {
  opened: boolean
  onClose: () => void
}

const ScratchRecordModal: React.FC<ScratchRecordModalProps> = ({ opened, onClose }) => {
  const [records, setRecords] = useState<LotteryRecordVO[]>([])

  useEffect(() => {
    if (opened) {
      Promise.all([lotteryRecords()])
        .then(([recordsData]) => {
          setRecords(recordsData)
        })
        .catch()
    }
  }, [opened])

  const getPrizeIcon = (prizeType: number) => {
    if (prizeType === 1) return '🧧' // 现金红包
    if (prizeType === 2) return '💎' // 积分
    return '🎯' // 默认
  }

  const getPrizeColor = (prizeType: number) => {
    if (prizeType === 1) return '#00B42A' // 现金红包
    if (prizeType === 2) return '#FF8C00' // 积分
    return '#FF5A5A' // 默认
  }

  const isWinningPrize = (prizeType: number) => {
    return prizeType === 1 || prizeType === 2
  }

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton={false}
      padding={0}
      zIndex={1100}
      overlayProps={{ opacity: 0.9 }}
      styles={{
        body: { padding: 0, background: 'transparent', boxShadow: 'none' },
        content: { background: 'transparent', boxShadow: 'none' },
      }}
    >
      <Image src="/lotteryRecord.png" alt="抽奖记录" />
      <div style={{ background: '#fff' }}>
        <div
          style={{
            padding: '16px 24px 0 24px',
            minHeight: 120,
            maxHeight: 200,
            overflowY: 'auto',
            scrollbarWidth: 'thin',
          }}
        >
          <Stack gap={0}>
            {records.length > 0 ? (
              records.map((record, idx) => (
                <div key={idx}>
                  <Flex justify="space-between" align="center" py={12}>
                    <Flex align="center" gap={12}>
                      {/* 使用表情符号替代图片 */}
                      <div
                        style={{
                          width: 32,
                          height: 32,
                          borderRadius: '50%',
                          background: 'linear-gradient(135deg, #FFE4E1 0%, #FFD1D1 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: 16,
                        }}
                      >
                        {getPrizeIcon(record.prizeType)}
                      </div>

                      <div>
                        <Text
                          size="sm"
                          fw={600}
                          style={{
                            color: getPrizeColor(record.prizeType),
                            marginBottom: 2,
                          }}
                        >
                          {record.prizeName}
                        </Text>
                        <Text size="xs" style={{ color: '#999' }}>
                          {new Date(record.drawTime).toLocaleDateString('zh-CN', {
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                          })}
                        </Text>
                      </div>
                    </Flex>

                    <div
                      style={{
                        padding: '4px 8px',
                        borderRadius: 12,
                        background: isWinningPrize(record.prizeType)
                          ? 'rgba(255, 90, 90, 0.1)'
                          : 'rgba(153, 153, 153, 0.1)',
                        border: `1px solid ${isWinningPrize(record.prizeType) ? 'rgba(255, 90, 90, 0.2)' : 'rgba(153, 153, 153, 0.2)'}`,
                      }}
                    >
                      <Text
                        size="xs"
                        fw={600}
                        style={{
                          color: isWinningPrize(record.prizeType) ? '#FF5A5A' : '#999',
                        }}
                      >
                        {isWinningPrize(record.prizeType) ? '已中奖' : '未中奖'}
                      </Text>
                    </div>
                  </Flex>
                  {idx !== records.length - 1 && (
                    <div
                      style={{
                        height: '1px',
                        background: 'linear-gradient(90deg, transparent 0%, #DFDFDF 50%, transparent 100%)',
                        margin: '0 -8px',
                      }}
                    />
                  )}
                </div>
              ))
            ) : (
              <Flex direction="column" align="center" justify="center" h={120}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>🎯</div>
                <Text c="#999999" size="sm" fw={500}>
                  暂无抽奖记录
                </Text>
                <Text c="#BBB" size="xs" style={{ marginTop: 4 }}>
                  快去体验刮奖的乐趣吧！
                </Text>
              </Flex>
            )}
          </Stack>
        </div>
        <Image src={'/iknow.png'} onClick={onClose} />
      </div>
    </Modal>
  )
}

export default ScratchRecordModal
